class BlockContact {
	constructor() {
		const contactLists = document.querySelectorAll(".block-contact .card-contact-multiple");

		contactLists.forEach(list => {
			const contact = list.querySelectorAll(".card-contact-multiple-name");

			contact.forEach(name => {
				name.addEventListener('click', () => {
					name.classList.toggle('active');
				});
			});

		});
	}
}